module.exports = __webpack_public_path__ + "media/images/USA-groom-image2-34909c67fc98a471a022997d0e78cce0.jpg";